import { toast } from "react-toastify";
import { apiUrl } from "utils/api";

const useStoreOrder = () => {
  const placeOrder = async (payload, totalPrice, products) => {
    try {
      const res = await fetch(apiUrl("order"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || "Order failed");
      } else {
        const order = data;

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: "purchase",
          ecommerce: {
            transaction_id: String(order.same_order_id || Date.now()),
            value: Number(totalPrice),
            currency: "BDT",
            items: products.map((item) => ({
              item_id: String(item.item_id),
              item_name: item.selectedVariant?.title,
              price: Number(item.selectedVariant?.flashPrice),
              quantity: item.quantity || 1,
              item_category: item.catalogue_title,
            })),
          },
        });
      }

      return data;
    } catch (error) {
      toast.error("⚠️ নেটওয়ার্ক সমস্যার কারণে অর্ডার সম্পন্ন হয়নি।");
      throw error;
    }
  };

  const cancelOrder = async (payload) => {
    try {
      const res = await fetch(apiUrl("storeUserCanceledOrder"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || "Cancel order failed");
      }

      return data;
    } catch (error) {
      console.error("Cancel order error:", error);
      throw error;
    }
  };

  return {
    placeOrder,
    cancelOrder,
  };
};

export default useStoreOrder;
